import _ from 'lodash';
import { MILLISECOND_PRECISION } from './fullstory-constants';
export const getLatencyFromServerTimingHeader = (serverTimingHeaderValue, serviceName) => {
    if (!serverTimingHeaderValue) {
        return null;
    }
    const prismValue = serverTimingHeaderValue
        .toLowerCase()
        .split(', ')
        .find(str => str.includes(serviceName));
    const prismLatency = parseFloat(prismValue.substring(prismValue.indexOf('dur=') + 4));
    return _.round(prismLatency, MILLISECOND_PRECISION);
};
//# sourceMappingURL=fullstory-utils.js.map